module.exports = __webpack_public_path__ + "static/media/undraw_book_lover_mkck.5c052fee.svg";